import { checkerboardSwatches } from '@/components/CustomCheckerboard/MainViews/SizeSelector/combinations';
export default function({ $store, $eventBus }) {
  return {
    install(Vue) {
      Vue.prototype.$recipe = {
        recipeMatchesPDM() {
          return $store.state.utils.pdm.partnumber === $store.state.recipe.recipe_v2.bundle_partnumber;
        },

        /**
         * @function setDefaultRecipe
         * This function set initRecipe and recipe_v2 with defaultRecipe.
         */
        setDefaultRecipe() {
          $store.commit("recipe/SET_RECIPE_V2", $store.state.recipe.defaultRecipe);
          $store.commit("recipe/SET_INIT_RECIPE", $store.state.recipe.defaultRecipe);
          $store.commit('recipe/SET_RECIPE_ID', $store.state.recipe.defaultRecipe.recipe_id);
        },

        setDefaultRecipeFromPdm() {
          $store.dispatch("recipe/GET_RECIPE", { recipe_id: $store.state.utils.pdm.default_recipe, setData: true })
            .then(data => {
              $store.commit("recipe/SET_DEFAULT_RECIPE", data);
              $store.commit("recipe/SET_RECIPE_V2", data);
              $store.commit("recipe/SET_INIT_RECIPE", data);
            });
        },

        /**
         * @function update
         * Updates the recipe when swacth is selected
         * Gets the passed swatch ID object and updates the
         * passed component with the swatch response data
         * @param {String} componentName
         * @param {Integer} swatchId
         */
        update(componentName, swatchId, recipeMapEntry = null, color = null) {
          return new Promise((resolve, reject) => {
            if ($store.getters['utils/isApparelEnabled']) {
              this.updateApparel(componentName, swatchId, recipeMapEntry, color);
              return resolve();
            }
            const componentObj = { ...$store.state.recipe.recipe_v2.components[componentName] };
            if (!componentObj) {
              return resolve();
            }
            const beforeSubgroup = componentObj.subgroup;
            const swatch = $store.getters['swatches/returnSwatchObj']({ swatchId: swatchId });

            if(!$store.getters["swatches/isUGCFromPrecreated"]({ swatchId, componentName })) {
              componentObj.group = $store.getters["swatches/returnSwatchGroupName"]({ swatch });
              componentObj.subgroup = $store.getters["swatches/returnSwatchSubgroupName"]({ swatch });
            }

            if(swatchId !== componentObj.swatch_id || recipeMapEntry) {
              this.removeToolkitOptions(componentName);
              $store.dispatch("recipe/UPDATE_RECIPE_COMPONENT",{
                componentName,
                swatchId,
                group: recipeMapEntry ? recipeMapEntry.group : componentObj.group,
                subgroup: recipeMapEntry ? recipeMapEntry.subgroup : componentObj.subgroup,
                material_type: recipeMapEntry ? recipeMapEntry.material_type : swatch.material_type,
                factorySwatchGroup: swatch.factorySwatchGroup,
                factorySwatchSubgroup: swatch.factorySwatchSubgroup,
                ugc: swatch.ugc,
                updatePrice: swatch.factorySwatchSubgroup ? beforeSubgroup !== swatch.factorySwatchSubgroup :  beforeSubgroup !== componentObj.subgroup
              });
              return resolve();
            }
          });
        },
        /**
         * @function updateApparel
         * Updates the recipe when swacth is selected
         * Gets the passed swatch ID object and updates the
         * passed component with the swatch response data
         * @param {String} componentName
         * @param {Integer} swatchId
         */
         async updateApparel(componentName, swatchId, recipeMapEntry = null, color = null) {
          let componentObj;
          if (componentName.search('/') !== -1) {
            const component = componentName.split('/');
            componentObj = { ...$store.state.recipe.recipe_v2.components[component[0]].sub_components[component[1]]};
          } else {
            componentObj = { ...$store.state.recipe.recipe_v2.components[componentName] };
          }

          if (!componentObj) {
            return;
          }
          const beforeSubgroup = componentObj.subgroup;
          const swatch = $store.getters['swatches/returnSwatchObj']({ swatchId: swatchId });

          if(!$store.getters["swatches/isUGCFromPrecreated"]({ swatchId, componentName })) {
            componentObj.group = $store.getters["swatches/returnSwatchGroupName"]({ swatch });
            componentObj.subgroup = $store.getters["swatches/returnSwatchSubgroupName"]({ swatch });
          }

          const shouldUpdateComponent = (
            swatchId !== componentObj.swatch_id
            || recipeMapEntry
            // support for pick your own color
            || (
              componentObj.subgroup === "standard-ugc-solids"
              && swatch.color !== componentObj.toolkit_options.hex
            )
          );
          if (shouldUpdateComponent) {
            const data = {
              componentName,
              swatchId,
              group: recipeMapEntry ? recipeMapEntry.group : componentObj.group,
              subgroup: recipeMapEntry ? recipeMapEntry.subgroup : componentObj.subgroup,
              material_type: recipeMapEntry ? recipeMapEntry.material_type : swatch.material_type,
              factorySwatchGroup: swatch.factorySwatchGroup,
              factorySwatchSubgroup: swatch.factorySwatchSubgroup,
              ugc: swatch.ugc,
              updatePrice: swatch.factorySwatchSubgroup ? beforeSubgroup !== swatch.factorySwatchSubgroup :  beforeSubgroup !== componentObj.subgroup,
            }
            if (componentName.search('/') === -1) {
              this.removeToolkitOptions(componentName);
              if ($store.state.utils.pdm.components?.[componentName]?.graphicspackage) {
                const graphic = await $store.dispatch('gdm/GET_GDM', { id: swatchId, component3D: componentName });
                // TODO handle non-solids sub_components
                const placementSetting = $store.state.graphicsController.placementSetting.find(item => item.placementComponent === componentName)
                // sets the default values of the GDM components (defaults don't overwrite user_defined values, only previous defaults)
                for (let i = 0; i < graphic.component.length; i++) {
                  const itemSwatchId = Number(graphic.component[i].swatch_id);
                  const itemSwatch = $store.getters['swatches/returnSwatchObj']({ swatchId: itemSwatchId });
                  $store.commit("graphicsController/SET_PLACEMENT_SETTING", {
                    placementComponent: componentName,
                    componentSetting: { id: graphic.component[i].id, swatch_id: itemSwatchId, hex: itemSwatch.color },
                    type: "default",
                  })
                }
                this.updateApparelGraphic(graphic, placementSetting, data);
              }
            } else {

              const componentID = componentName.split('/')[0];
              const subComponentID = componentName.split('/')[1];
              const subComponent = $store.state.recipe.recipe_v2.components[componentID].sub_components[subComponentID];
              const toolkit = subComponent.toolkit_options;
              const swatch = $store.state.utils.availableSwatches.find(item => item.id === String(swatchId));
              toolkit.hex = swatch.subgroup === "standard-ugc-solids" ? color : swatch.color;
              if (!toolkit.hex) delete toolkit.hex
            }

            data.material_type = $store.getters["utils/componentsWithGraphicsSupport"].includes(data.componentName) ? 'graphic' : data.material_type

            $store.dispatch("recipe/UPDATE_RECIPE_COMPONENT", data);
          }
        },

        /**
         * @function updateComponents
         * @param {String} parentComponentName
         * @param {String} swatchId
         * This function updates the recipe when a swatch is selected.
         * Gets the passed swatch ID object and updates a group of
         * component referencing the parent component and updating it
         * with the swatch response data.
         */
        updateComponents(parentComponentName, swatchId, componentGroup = null, recipeMapEntry = null, color = null) {
          return new Promise((resolve, reject) => {
            if(!swatchId || !parentComponentName)  resolve(false);
            swatchId = parseInt(swatchId);
            if (!componentGroup) {
              componentGroup = $store.state.utils.pdm.components[parentComponentName] &&
                    $store.state.utils.pdm.components[parentComponentName].component_configuration_group;
            }

            if (Array.isArray(componentGroup) && !!componentGroup.length) {
              const promises = [];
              componentGroup.forEach((name, index, self) => promises.push(this.update(name, swatchId, recipeMapEntry, color)));
              Promise.all(promises).then(resolve);
            } else {
              this.update(parentComponentName, swatchId, recipeMapEntry, color).then(() => {
                resolve();
              })
            }
          });
        },

         /**
         * @function updateApparelGraphic
         * Updates the recipe when new graphic is selected
         * Gets the passed graphic object and updates the
         * passed component with the response data
         * @param {object} graphic
         * @param {object} placementSetting
         * @param {object} data
         */
        updateApparelGraphic(graphic, placementSetting, data) {

           // updates the sub_components attribute of the component
           data.sub_components = graphic.component
           .map((item) => {
               const componentSetting =  placementSetting?.componentSetting?.find(c => c.id === item.id);
               if (componentSetting?.hex?.length > 7 && !item?.transparent) {
                 // use the default gdm color if transparent not allowed
                 componentSetting.swatch_id = item.swatch_id;
                 componentSetting.hex = item.hex;
               }

               if (componentSetting?.transparent && item?.transparent) {
                 //use transparent swatch if previously set and allowed
                 componentSetting.swatch_id = $store.state.gdm.config[0].global.transparent_swatch_id;
                 const swatchId = componentSetting.swatch_id;
                 const swatchObj = $store.getters["swatches/returnSwatchObj"]({ swatchId });
                 componentSetting.hex = swatchObj.color;
               }
               let component;
               if (componentSetting) {
                 component = {
                   ...item,
                   hex: componentSetting.hex,
                   swatch_id: Number(componentSetting.swatch_id),
                   pattern: componentSetting.pattern,
                   has_ugc: componentSetting.has_ugc,
                   toolkit_options: componentSetting.toolkit_options,
                   ugc: componentSetting.ugc,
                 };
               } else {
                 component = { ...item };
               }
               // removes the ugc attribute that comes from the GMD when
               // subcomponent is not UGC
               if (!component.has_ugc) delete component.ugc;
               return component;
             })
             .map((item) => {
               const itemSwatch = $store.getters['swatches/returnSwatchObj']({ swatchId: item.swatch_id });
               const itemGroup = itemSwatch ? $store.getters["swatches/returnSwatchGroupName"]({ swatch: itemSwatch }) : "solids";
               const itemSubgroup = itemSwatch ? $store.getters["swatches/returnSwatchSubgroupName"]({ swatch: itemSwatch }) : "solids-apparel";
               return {
                 [item.id]: {
                   swatch_id: item.swatch_id ?? 11021,
                   toolkit_options: item.toolkit_options ?? itemSwatch?.toolkit_options ?? {
                     hex: item.hex ?? itemSwatch.color,
                   },
                   group: item.has_ugc ? "ugc" : itemGroup,
                   material_type: itemSwatch?.material_type ?? "svg",
                   subgroup: item.has_ugc ? "ugc" : itemSubgroup,
                   ugc: item.ugc,
                 }
               }
             })
             .reduce(
               (item, acc) => Object.assign(item, acc),
               {}
             );

          return data;
        },
        /**
          * @function updateUGC
          * @param {String} ugcComponent
          * @param {Object} ugcObj
          * This function updates the recipe component adding ugcObject in specific component.
          * It is only used in one function, saveMultipleUGCComponents is not longer used.
          */
        updateUGC(ugcComponent, ugcObj={}, subgroup = null, tempData = false) {
          const { activeUGCIndex } = $store.state.ugc.tempData;
          const { components } = tempData ? $store.state.ugc.tempData.features[activeUGCIndex].recipe : $store.state.recipe.recipe_v2;
          const ugcFeature = tempData ? $store.state.ugc.tempData.features[activeUGCIndex].ugcFeature : null;
          let data = components[ugcComponent];
          data.ugc = ugcObj;
          if ($store.getters['utils/isGCC']){
            data.ugc.gcc = true;
          }
          // Remove temp img object for calculating stitch color.
          data.group = "ugc";
          data.subgroup = subgroup || ugcFeature || "ugc";
          data.material_type = "canvas";

          // if applying ugc from imageLibrary swatch ID is the same so we need to handle remove toolkit options
          if (data.subgroup === 'ugc') {
            this.removeToolkitOptions(ugcComponent);
          }

          if (tempData) {
            $store.commit("ugc/tempData/UPDATE_COMPONENT", { componentName: ugcComponent, data });
          } else {
            $store.commit("recipe/UPDATE_COMPONENT", { componentName: ugcComponent, data });
          }
        },

        /**
          * @function updatePattern
          * @param {String} - componentName - name of the component
          * @param {Object} - ugc - object with ugc data
          * @param {string} - swatchID - Id of the swatch created
          * This function updates the recipe component adding patternMaker data in specific component.
          * This function is a unique method to handle custom patternMaker, and is used only in applyPatternSwatch from configurationUGC.
          * Should never be called directly.
          */
        updatePattern(componentName, ugc, swatchId, updatePrice = true) {
          this.removeToolkitOptions(componentName);
          return $store.dispatch('recipe/UPDATE_RECIPE_COMPONENT', {
            componentName,
            swatchId,
            ugc: JSON.parse(JSON.stringify(ugc)),
            group: 'ugc',
            subgroup: 'checkerboard-creator',
            material_type: 'canvas',
            updatePrice: updatePrice
          });
        },

        /**
          * @function checkForPersonalization
          * This function checks if at least one component in recipe has personalization property.
          */
         checkForPersonalization() {
          const { components } = $store.state.recipe.recipe_v2;
          let check = components && Object.keys(components).find( item => components[item].hasOwnProperty("personalization"));
          return !!check;
        },

        /**
          * @function getPersonalizationComponentName
          * This function returns the component in recipe has personalization property.
          */
        getPersonalizationComponentName() {
          if (this.checkForPersonalization()) {
            const { components } = $store.state.recipe.recipe_v2;
            return Object.keys(components).find( item => components[item].hasOwnProperty("personalization"));
          }
          return null;
        },

        /**
         * @function checkUGCByType
         * @param {Boolean} includePatternMaker Flag to consider patternMaker in the search
         * @param {Boolean} includeCustomCheckerboard Flag to consider customCheckerboard in the search
         * @param {Boolean} includeUGCAsSwatch Flag to consider ugcSAsSwatch in the search
         * @param {Boolean} customUGC Flag to consider customUGC in the search
         * This function checks if one type of ugc is present in the recipe
         * If all the flags are false returns false without searching.
         * Be sure that default recipe is saved before using this function.
         */
        checkUGCByType({ includePatternMaker = false, includeUGCAsSwatch = false, customUGC = false, includeCustomCheckerboard = false }) {
          if (!includePatternMaker && !includeUGCAsSwatch && !customUGC && !includeCustomCheckerboard) {
            return false;
          }
          const { recipe_v2: { components }, defaultRecipe } = $store.state.recipe;
          for (let item in components) {
            if (includePatternMaker) {
              if (components[item].hasOwnProperty("ugc") && components[item].subgroup === 'checkerboard-creator'){
                return true;
              }
            }
            if (includeUGCAsSwatch) {
              if (components[item].hasOwnProperty("ugc") && defaultRecipe.components[item] && components[item].swatch_id != defaultRecipe.components[item].swatch_id){
                return true;
              }
            }
            if (customUGC) {
              if (components[item].hasOwnProperty("ugc") && defaultRecipe.components[item] && components[item].swatch_id == defaultRecipe.components[item].swatch_id){
                return true;
              }
            }
            if (includeCustomCheckerboard) {
              if (components[item].hasOwnProperty("ugc") && components[item].subgroup === 'custom-checkerboard') {
                return true;
              }
            }
          }
          return false;
        },

        /**
          * @function checkApparelUGC
          * This function checks if at least one component in recipe has ugc property.
          */
        checkApparelUGC() {
          const activeComponent = $store.state.standardNavigation.activeComponent;
          const subcomponents =  $store.state.recipe.recipe_v2?.components?.[activeComponent]?.sub_components;
          if(subcomponents) {
            for (let subcomponent of Object.keys(subcomponents)) {
              if(subcomponents[subcomponent]?.ugc) {
                return true;
              }
            }
          }
          return false;
        },

        /**
          * @function checkForUGC
          * This function checks if at least one component in recipe has ugc property.
          */
        checkForUGC() {
          const { components } = $store.state.recipe.recipe_v2;
          let check = components && Object.keys(components).find( item => components[item].hasOwnProperty("ugc"));
          return !!check;
        },
        /**
          * @function checkForPatternMaker
          * This function returns components in recipe that have checkerboard-creator property.
          */
        checkForPatternMaker() {
          const { components } = $store.state.recipe.recipe_v2;
          return components ? Object.keys(components).filter( item => components[item].subgroup === 'checkerboard-creator') : [];
        },
        /**
          * @function checkForImageLibrary
          * This function returns components in recipe that have library subgroup and ugc property.
          */
        checkForImageLibrary() {
          const { components } = $store.state.recipe.recipe_v2;
          return components
            ? Object.keys(components).filter( item => components[item].hasOwnProperty("ugc") && components[item].subgroup === 'library')
            : [];
        },
        /**
          * @function checkForImageLibraryComponent
          * @param {String} componentName
          * This function checks if Image Library IS on on recipe_v2 for a specific component and return a boolean value.
          */
        checkForImageLibraryComponent(componentName) {
          const component = $store.state.recipe.recipe_v2.components && $store.state.recipe.recipe_v2.components[componentName];
          return component &&
            component.hasOwnProperty("ugc") &&
            component.hasOwnProperty("subgroup") &&
            component.subgroup === "library";
        },
        /**
          * @function checkForUGCComponent
          * @param {String} componentName
          * This function checks if UGC IS on on recipe_v2 for a specific component and return a boolean value.
          */
        checkForUGCComponent(componentName) {
          if ($store.state.recipe.recipe_v2.components[componentName] &&
              $store.state.recipe.recipe_v2.components[componentName].hasOwnProperty("ugc")) {
            return true;
          }
          return false;
        },

        /**
          * @function checkForUGCComponent
          * @param {String} componentName
          * This function checks if UGC IS on on recipe_v2 for a specific component and return a boolean value.
          */
        checkForCustomCheckerboardComponent(componentName) {
          const component = $store.state.recipe.recipe_v2.components && $store.state.recipe.recipe_v2.components[componentName];
          return component &&
            component.hasOwnProperty("ugc") &&
            component.hasOwnProperty("subgroup") &&
            component.subgroup === "custom-checkerboard";
        },

        /**
          * @function isRecipeChanged
          * This function checks if recipe was changed and return a booelan value.
          */
        isRecipeChanged() {
          let isDifferentRecipe = false;
          const recipeV2 = JSON.stringify($store.state.recipe.recipe_v2);
          const defaultRecipe = JSON.stringify($store.state.recipe.defaultRecipe);
          const { tempData } = $store.state.ugc;
          const ugcTempRecipe = tempData.features[tempData.activeUGCIndex].recipe;
          const ugcSteps = $store.state.ugc.stateManager.steps;

          if (Object.entries($store.state.recipe.savedRecipe)) {
            isDifferentRecipe = (JSON.stringify($store.state.recipe.savedRecipe) !== recipeV2)
          } else if (ugcTempRecipe && Object.entries(ugcTempRecipe)) {
            isDifferentRecipe = (JSON.stringify(ugcTempRecipe) !== recipeV2)
          } else if(document.querySelectorAll("[data-modal='patternMaker']").length) {
            isDifferentRecipe = true;
          } else {
            isDifferentRecipe = (recipeV2 !== defaultRecipe);
          }
          return isDifferentRecipe;
        },

        getUGCComponents() {
          const { components } = $store.state.recipe.recipe_v2;
          const componentKeys = Object.keys(components);
          const ugcComponents = componentKeys.filter(component =>
              components[component].hasOwnProperty("ugc")
          );
          if (ugcComponents.length) {
            return ugcComponents;
          } else {
            console.log('No component with UGC detected');
            return false;
          }
        },

        /**
          * @function updateUgcSize
          * @param {String} size
          */
        updateUgcSize(size) {
          const { components } = $store.state.recipe.recipe_v2;
          let data;
          for (let item in components) {
            if (components[item].ugc) {
              const swatch = $store.getters['swatches/returnSwatchObj']({ swatchId: components[item].swatch_id });
              if (swatch && swatch.ugc) {
                data = components[item];
                data.ugc.size = size;
                $store.commit("recipe/UPDATE_COMPONENT", { componentName: item, data });
              }
            }
          }
        },

        getSize(componentName) {
          const { pdm } = $store.state.utils;
          const { bucketSizes } = $store.state.utils;
          let result = bucketSizes[pdm.ugcDefaultSize];
          if (componentName && $store.state.recipe.recipe_v2.components[componentName]) {
            const currentComponent = $store.state.recipe.recipe_v2.components[componentName];
            if (currentComponent.hasOwnProperty("ugc")) {
              if (bucketSizes.hasOwnProperty(currentComponent.ugc.size)) {
                result = bucketSizes[currentComponent.ugc.size];
              } else {
                let data = $store.state.recipe.recipe_v2[componentName];
                data.ugc.size = result;
                $store.commit("recipe/UPDATE_COMPONENT", { componentName, data });
              }
            }
          }
          return result;
        },

        /**
         * @function componentUpdated
         * @param {String} componentName
         * This functions checks if the component has changed and return a boolean value.
         * Takes a second param if you want to compare defaultRecipe instead
         */
        componentUpdated(componentName, recipeType) {
          if (componentName) {
            const initComponent = $store.state.recipe.initRecipe.components[componentName];
            const recipeV2Component = $store.state.recipe.recipe_v2.components[componentName];
            const swatchNew = recipeV2Component && Number(recipeV2Component.swatch_id);
            let swatchOriginal = initComponent && Number(initComponent.swatch_id);
            if (recipeType === 'default') {
              const defaultComponent = $store.state.recipe.defaultRecipe.components[componentName];
              swatchOriginal = defaultComponent && Number(defaultComponent.swatch_id);
            }
            return swatchOriginal !== swatchNew;
          }
        },

        /**
         * @function getUGCSizeFromRecipe
         * This function return the size of the model in the ugc object
         * in any component on the recipe.
         */
        getUGCSizeFromRecipe() {
          let size = false;
          const { components } = $store.state.recipe.recipe_v2;
          const ugcComponents = Object.keys(components).filter(componentName => this.getUGCFeatureType(componentName) === 'ugc');

          if (ugcComponents.length) {
            size = components[ugcComponents[0]].ugc.size;
          } else {
            for (let item in components) {
              if (components[item] && components[item].ugc) {
                size = components[item].ugc.size;
                break;
              }
            }
          }

          return size;
        },

        /**
         * @function getCustomUGCSizeFromRecipe
         * This function return the size of the model in the ugc object
         * in any component on the recipe
         * Only returns size for UGC applied by the user and not ugc as swatch or checkerboars.
         */
        getCustomUGCSizeFromRecipe() {
          let size = false;
          const { components } = $store.state.recipe.recipe_v2;
          for (let item in components) {
            const swatch = $store.getters["swatches/returnSwatchObj"]({ swatchId: components[item].swatch_id});
            const checkSwatch = swatch && !swatch.ugc && swatch.subgroup !== "checkerboard-creator";
            if (components[item] && components[item].ugc && checkSwatch) {
              size = components[item].ugc.size;
              break;
            }
          }
          return size;
        },
        /**
         * @function removeUGCSwatchfromRecipe
         * @param {String} componentName
         * Removes UGC from recipe and resets the model.
         */
        removeUGCSwatchfromRecipe({componentName, componentWithUGCArray, applyUndo, swatch}) {
          const { tempData } = $store.state.ugc;
          if (this.checkForUGCComponent(componentName) && componentName === tempData.features[tempData.activeUGCIndex].activeUGCComponent ||
              (this.checkForUGCComponent(componentName) && applyUndo)) {
            if (componentWithUGCArray.length <= 1) { // clear if single UGC component applied
              $store.commit("swatches/SET_DISABLED_SWATCHES_BY_FEATURE", {
                swatches: [],
                feature: this.getUGCFeatureType(componentName)
              });
            }
            $store.commit("recipe/REMOVE_COMPONENT_PROPERTY", {componentName, property: 'ugc'});
          }
        },
        /**
       * @function removeApparelUGCSwatchfromRecipe
       * @param {String} componentName
       * Removes UGC from Apparel recipe.
       */
        removeApparelUGCSwatchfromRecipe(componentName) {
          $store.commit("recipe/REMOVE_COMPONENT_PROPERTY", {componentName, property: 'ugc'});
        },
        /**
         * @function getUGCFeatureType
         * @param {String} - componentName
         * @returns {String} - return the UGC feature type in the state recipe object
         */
        /* The above code is getting the feature type of the UGC layer. */
        getUGCFeatureType(componentName) {
          if (!$store.state.recipe.recipe_v2.components[componentName]) return false;
          const hasSubcomponent = String(componentName).search('/') > -1;
          const component = componentName.split('/');
          const storeComponent = hasSubcomponent
            ? $store.state.recipe.recipe_v2.components[component[0]].sub_components[component[1]]
            : $store.state.recipe.recipe_v2.components[componentName];

          if (!$store.state.recipe.defaultRecipe.components) return false;
          if (!hasSubcomponent && !$store.state.recipe?.defaultRecipe?.components[componentName]?.swatch_id) return false;
          if (hasSubcomponent && !$store.state.recipe?.defaultRecipe?.components[component[0]]?.sub_components[component[1]]?.swatch_id) return false;

          const swatchId  = hasSubcomponent
            ? $store.state.recipe.defaultRecipe.components[component[0]].sub_components[component[1]].swatch_id
            : $store.state.recipe.defaultRecipe.components[componentName].swatch_id;

          const { group, subgroup, swatch_id, ugc } = storeComponent;
          if (group === 'ugc' && subgroup === 'checkerboard-creator') {
            return 'patternMaker';
          } else if (group === 'ugc' && subgroup === 'custom-checkerboard') {
            return 'customCheckerboard';
          } else if (group === 'ugc' && subgroup === 'library') {
            return 'imageLibrary';
          } else if ((ugc && swatch_id === swatchId) && group !== "graphics") {
            return 'ugc';
          }

          return false;
        },
        /**
         * @function getComponentsSwatchApplied
         * Compare default recipe components against recipe_v2 components to get the components
         * that have been applied a swatch
         * @returns {Array} Components
         */
        getComponentsSwatchApplied(option) {
          const { components: recipeV2Components } = $store.state.recipe.recipe_v2;
          const { components: recipeDefaultComponents } = $store.state.recipe.defaultRecipe;
          const components = [];

          for (let item in recipeDefaultComponents) {
            if (option === 'deep') {
                 if (this.componentUpdated(item, 'default')) {
                  components.push(item);
                 }
                 else {
                   if (this.checkForUGCComponent(item)) {
                    components.push(item);
                   }
                 }
            } else {
              if (recipeV2Components[item] && recipeDefaultComponents[item].swatch_id !== recipeV2Components[item].swatch_id) {
                components.push(item);
              }
            }
          }
          return components;
        },
        /**
         * @function validateDefaultComponent -   Method to review if the recipe has UGC in a different default component
         * @return {String} componentName - Return the default componentName
         */
        getRecipeDefaultComponent() {
          const defaultComponent = $store.state.utils.pdm.default_component;
          const hasUGC = this.checkUGCByType({
            includePatternMaker: true,
            customUGC: true
          });
          if(hasUGC) {
            const ugcComponents = this.getUGCComponents();
            if(!ugcComponents.includes(defaultComponent)) {
              return ugcComponents.length > 0 ? ugcComponents[0] : defaultComponent;
            }
          }
          return defaultComponent;
        },
        /**
          * @function addToolkitOptions
          * @param {String} componentName component name
          * @param {Object} warpId  warp id
          * @param {Boolean} tempData update tempData instead of recipe_v2
          * This function updates the recipe component adding toolkit_options in specific component.
          * It is only used for customCheckerboard
          */
        addToolkitOptions(componentName, wrapId = 0, swatchId = 4, tempData = false) {
          const { components } = tempData ? $store.state.ugc.tempData.features[$store.state.ugc.tempData.activeUGCIndex].recipe : $store.state.recipe.recipe_v2;
          let data = components[componentName];
          const { components : customsComp , canvasConfig } = $store.state.customCheckerboard
          const configurationColor =  customsComp[componentName] ? customsComp[componentName].canvasConfig : canvasConfig;
          const toolKitObject =  {
            "combination_id": wrapId,
            "hex_1": configurationColor.color1,
            "hex_2": configurationColor.color2
          };
          data.toolkit_options = toolKitObject;
          data.swatch_id = swatchId;

          if (tempData) {
            $store.commit("ugc/tempData/UPDATE_COMPONENT", { componentName: componentName, data });
          } else {
            $store.commit("recipe/UPDATE_COMPONENT", { componentName: componentName, data });
          }
        },

        /**
          * @function extractToolkitOptions
          * @param {String} componentName component name
          * @param {Boolean} tempData update tempData instead of recipe_v2
          * This function extracts from the recipe the toolkit_options in specific component.
          */
        extractToolkitOptions(componentName, checkerboardCombination) {
          const component = $store.state.recipe.recipe_v2.components[componentName];

          if (!component.toolkit_options) return {};

          const {
            hex_1 = null,
            hex_2 = null,
            combination_id = null
          } = component.toolkit_options;
          let warp = 'noWarp';
          let size = 'small';

          // Get combination_id from the swatch id
          for (const keySize in checkerboardCombination) {
            for (const keyWarp in checkerboardCombination[keySize]) {
              if(checkerboardCombination[keySize][keyWarp].swatchId === component.swatch_id) {
                  warp = keyWarp;
                  size = keySize;
              }
            }
          }

          return {
            hex_1,
            hex_2,
            warp,
            size,
          };
        },

        /**
          * @function removeToolkitOptions
          * @param {String} componentName component name
          * This function removes from the recipe the toolkit_options in specific component.
          */
        removeToolkitOptions(componentName = $store.state.legacyNavigation.activeComponent) {
          let recipeComponent;
          if (componentName.search('/') !== -1) {
            const component = componentName.split('/');
            recipeComponent = { ...$store.state.recipe.recipe_v2.components[component[0]].sub_components[component[1]]};
          } else {
            recipeComponent = { ...$store.state.recipe.recipe_v2.components[componentName] };
          }

          if (recipeComponent && recipeComponent.toolkit_options) {
            $store.commit("recipe/REMOVE_COMPONENT_PROPERTY", { componentName, property: 'toolkit_options' });
          }
        },

        /**
         * @function getInvalidUGCComponents
         * Validates that components that have UGC are correctly set up. Returns all component names that are invalid.
         *
         * Custom UGC - must have the default swatch id, group == ugc, subgroup = { ugc | holidaytool | checkerboarder | custom-checkerboard | checkerboard-creator }
         * UGC as a Swatch - must have a swatch id different from the default
         */
        getInvalidUGCComponents(recipe) {
          const invalidComponents = [];
          const { components } = recipe;
          const customUGCSubgroups = [ 'ugc', ...$store.state.ugc.availableUgcFeatures ];
          for (let component in components) {
            const componentObj = components[component];
            if ($store.state.recipe.defaultRecipe.components[component] && componentObj.swatch_id === $store.state.recipe.defaultRecipe.components[component].swatch_id) {
              if (!!componentObj.ugc && componentObj.group === 'ugc' && customUGCSubgroups.includes(componentObj.subgroup)) {
                continue;
              }
            }
            const swatchObj = $store.state.utils.availableSwatches.find(swatch => Number(swatch.id) === componentObj.swatch_id);
            if (swatchObj) {
              if (!!swatchObj.ugc &&
                swatchObj.factorySwatchGroup === componentObj.group &&
                swatchObj.factorySwatchSubgroup === componentObj.subgroup) {
                continue;
              }
              else if (!swatchObj.ugc &&
                $store.getters["swatches/returnSwatchGroupName"]({ swatch: swatchObj }) === componentObj.group &&
                $store.getters["swatches/returnSwatchSubgroupName"]({ swatch: swatchObj }) === componentObj.subgroup) {
                continue;
              }
            } else {
              // This validation is for Pattern Maker / custom-checkerboard since they have a different swatch id
              if (!!componentObj.ugc && componentObj.group === 'ugc') {
                if (componentObj.subgroup === 'custom-checkerboard' &&
                  !!componentObj.toolkit_options &&
                  checkerboardSwatches.includes(componentObj.swatch_id)) {
                  continue;
                } else if (componentObj.subgroup === 'checkerboard-creator') {
                  continue;
                }
              }
            }
            invalidComponents.push(component);
          }
          return invalidComponents;
        },

        /**
         * @function getComponentUGCAndPersonalizationRelation
         * @param {String} component component name
         * Get the component ugc and personalization relations.
         */
        getComponentUGCAndPersonalizationRelation(component) {
          const { components } = $store.state.recipe.recipe_v2;
          const { swatchesRelation } = $store.state.swatches;
          let personalization_allowed = true;
          let ugc_allowed = true;

          for (const componentName in components) {
            const { swatch_id } = components[componentName];
            const relation = swatchesRelation[swatch_id];

            if (!relation) continue;

            if (componentName !== component && !relation.ugc_allowed) {
              ugc_allowed = false;
            }

            if (!relation.personalization_allowed) {
              personalization_allowed = false;
            }
          }

          return { personalization_allowed, ugc_allowed };
        },
        /**
         * Validate if the recipe_v2 is the same as default recipe with personalization
         */
        existPersonalizationWithDefaultRecipe(){
          const componentPersonalization = this.getPersonalizationComponentName();
          if(componentPersonalization){
            let tempRecipe = JSON.parse(JSON.stringify($store.state.recipe.recipe_v2.components));
            delete tempRecipe[componentPersonalization].personalization;
            return JSON.stringify(tempRecipe) === JSON.stringify($store.state.recipe.defaultRecipe.components);
          }
          return false;
        },
        getSwatchIdsInRecipes({recipeComponents = null, defaultComponents = null, component = ''}) {
          let recipeSwatchId, defaultSwatchId;
          if (component.includes("/")) {
            const components = component.split("/");
            if (recipeComponents) {
              recipeSwatchId = recipeComponents[components[0]]?.sub_components?.[components[1]]?.swatch_id;
            }
            if (defaultComponents) {
              defaultSwatchId = defaultComponents[components[0]]?.sub_components?.[components[1]]?.swatch_id
            }
          } else {
            if (recipeComponents) {
              recipeSwatchId = recipeComponents[component]?.swatch_id;
            }
            if (defaultComponents) {
              defaultSwatchId = defaultComponents[component]?.swatch_id;
            }
          }

          return { recipeSwatchId, defaultSwatchId }
        },
        checkIfDecostitchIsAllowed({ugcOnly}) {
          const ugcIsApplied = this.checkForUGC();
          const swatchIsUGCOnly = ugcOnly && ugcIsApplied;
          const components = $store.state.recipe.recipe_v2.components;
          let swatchAllowsDeco = false;
          for ( let i in components){
            const swatchAllowsDecostitchInComponent = $store.getters['swatches/returnSwatchObj']({"swatchId":$store.state.recipe.recipe_v2.components[i].swatch_id})?.swatchAllowsDecostitchInComponent;
            if(swatchAllowsDecostitchInComponent && swatchAllowsDecostitchInComponent === i) {
              swatchAllowsDeco =  swatchAllowsDecostitchInComponent === i;
              break;
            };
          };
          return swatchAllowsDeco || swatchIsUGCOnly || ugcIsApplied;
        },
        getComponentAllowedDecostitch() {
          return Object.keys($store.state.recipe.recipe_v2.components).filter(i => $store.getters['swatches/returnSwatchObj']({"swatchId":$store.state.recipe.recipe_v2.components[i].swatch_id})?.swatchAllowsDecostitchInComponent)[0];
        },
        getDecostitchColorFromRecipeComponent({swatch}) {
          const componentAllowedDecostitch = this.getComponentAllowedDecostitch();

          if(componentAllowedDecostitch){
            const swatchID = swatch?.id || $store.getters["recipe/getSwatchIdFromComponent"]({componentName: componentAllowedDecostitch});
            return $store.getters['swatches/returnSwatchObj']({"swatchId":swatchID}) && $store.getters['swatches/returnSwatchObj']({"swatchId":swatchID}).stitch_color;
          }
        }
      };
    }
  };
};
